import { GetApp } from "../../App"
import { Select } from "../../Components/Select"
import { LoginFooterViewProps } from "./Params"

export function LoginFooterView({ language, languageButtonText, languageOptions, handleLanguageChange, setResetDialog }: LoginFooterViewProps) {
  const app = GetApp()!;
  const t = app.getT("LoginView");

  return (
    <div className="LoginView-footer">
      <div className="footer-left">
        <Select
          className="language-selector"
          button={languageButtonText}
          value={language}
          onSelect={handleLanguageChange}
          options={languageOptions}
          title={t("footer_language")}
        />
      </div>
      {!app.cloudSession() && (
        <div className="footer-right">
          <button className="reset-app" onClick={() => setResetDialog(1)} title={t("footer_reset_app")}>
            {t("footer_reset_app")}
          </button>
        </div>
      )}
    </div>
  );
}
